window.addEventListener('load', (event) =>{
	/* Neswletter popup */
	/* -------------------------------------------------------------------------------------- */
	if (sessionStorage.getItem('dontLoad') == null){
		$('#id-newsletter-popup').addClass('active');
		sessionStorage.setItem('dontLoad', 'true');
	}
});